const OPTIMIZED_IMAGE_SIZE = "736x736";

export function toOptimizedPictureUrl(url?: string | null): string {
    if (!url) return "";
    try {
        const parsedUrl = new URL(url);

        if (!parsedUrl.hostname.startsWith("media.") || parsedUrl.hostname.startsWith("media-resize.")) return url;

        const newHost = parsedUrl.hostname.replace(/^media\./, "media-resize.");
        const parts = parsedUrl.pathname.split("/");

        if (parts.length >= 5 && parts[1] === "classifieds" && parts[3] === "pictures") {
            const classifiedUUID = parts[2];
            const imageFileName = parts.slice(4).join("/");
            return `https://${newHost}/classifieds/${classifiedUUID}/${OPTIMIZED_IMAGE_SIZE}/${imageFileName}`;
        }

        return url;
    } catch {
        return url;
    }
}

